<template>
    <div class="bigdata_container" id="bigdata" v-loading="isLoading" element-loading-text="拼命加载中..."
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            {{ orgName }}数据大屏
        </div>
        <div class="time">{{ currentTime }}</div>
        <div class="quanp">
            <!-- <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
                onFullScreen ? "退出全屏" : "进入全屏"
            }}</el-button> -->
            <img src="../../../assets/img/homecare/screen.png" @click="showFullScreen" class='screen' />
        </div>
        <div class="serach_wrapper">
            <treeselect v-model="regionId" :options="deptOptions" :normalizer="normalizer" :appendToBody="true"
                z-index="9999" placeholder="请选择区域" @select="deptSelect" style="width: 140px; height: 26px" />
            <img src="../../../assets/img/homecare/search.png" @click="handleSearch('search')"
                style="position:absolute;cursor: pointer;width:20px;height:20px;margin-top:3px;margin-left:152px" />
        </div>

        <transition name="nameoftransition">
            <div class="info_tisp" v-show="infoTisp">
                <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
            </div>
        </transition>
        <div class="bigdata_main" v-if="oldIndex === 0">
            <div id="container" style="width: 100%; height: 100%;margin-top:20px"></div>
            <div class="main_left">
                <div class="main_pane main_pane1">
                    <div class="titleHeader">
                        <div class="titleTxt">工单数量</div>
                    </div>
                    <div class="gdData" style="margin-left:20%">
                        <div class="h-flex">
                            <img src="../../../assets/img/homecare/clgd.png" alt="" class="img" />
                            <div class="">
                                <div class="value">{{ allData.orderCount }}</div>
                                <div class="title">残联工单总数</div>
                            </div>
                        </div>
                        <div class="h-flex">
                            <img src="../../../assets/img/homecare/gdsc.png" alt="" class="img" />
                            <div class="">
                                <div class="value">{{ allData.orderTime }}</div>
                                <div class="title">工单总时长</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 老人类别统计 -->
                <div class="main_pane main_pane2" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">服务比例</div>
                    </div>
                    <div id="echartsTwo" ref="echartsTwo" style="height: 85%; width: 100%;"></div>
                </div>
            </div>
            <div class="main_center">
                <div class="map">
                </div>
            </div>
            <div class="main_right">
                <div class="main_pane main_pane4">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">工单数量</div>
                    </div>
                    <div class="fourV gdData">
                        <div class="h-flex">
                            <img src="../../../assets/img/homecare/fwdx.png" alt="" class="img" />
                            <div>
                                <div class="value">{{ allData.serviceCount }}</div>
                                <div class="title">已服务人数</div>
                            </div>
                        </div>
                        <div class="h-flex">
                            <img src="../../../assets/img/homecare/cjzj.png" alt="" class="img" />
                            <div>
                                <div class="value">{{ allData.customerCount }}</div>
                                <div class="title">服务对象总数</div>
                            </div>
                        </div>
                        <div class="h-flex">
                            <img src="../../../assets/img/homecare/ybms.png" alt="" class="img" />
                            <div>
                                <div class="value">{{ allData.disabledOrganCount }}</div>
                                <div class="title">残疾人之家数量</div>
                            </div>
                        </div>
                        <div class="h-flex">
                            <img src="../../../assets/img/homecare/tyzx.png" alt="" class="img" />
                            <div>
                                <div class="value">{{ allData.tyzxOrganCount }}</div>
                                <div class="title">托养中心数量</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 服务工单类型 -->
                <div class="main_pane main_pane5" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <!-- <img src="../assets/img/title_icon.png" alt="" /> -->
                        </div>
                        <div class="titleTxt">服务对象比例</div>
                    </div>
                    <div id="echartsFour" ref="echartsFour" style="height:90%; width: 100%;margin-left:6%"></div>
                </div>

            </div>
        </div>
        <el-dialog :title="infotitle" :visible.sync="dialogVisible" width="30%" custom-class="speinfo"
            style='margin-top:28vh;' :before-close="handleClose">
            <div class="top">
                <div class="left">
                    <img :src="infoData.personPhoto" class='img' />
                    <div class="info">
                        <p v-if="typeValue == 2">站点名称：{{ infoData.statName }}</p>
                        <p v-else>姓名：{{ infoData.personName }}</p>
                        <p>联系方式：{{ infoData.personPhone }}</p>
                        <p class="add"><span class="first">地址：</span><span>{{ infoData.address }}</span></p>
                    </div>
                </div>
                <!-- <div class="right" @click="showVideo">视频通话</div> -->
            </div>
        </el-dialog>
        <!-- 弹窗 end -->
        <shipingtonghua v-if="videoModal" :userId="userinfo.id" :mobilePhone='userinfo.personPhone'
            :closeSP.sync="videoModal"></shipingtonghua>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import * as echarts from "echarts"
import shipingtonghua from "@/components/shipingtonghua.vue"
export default {
    name: "visualized",
    components: {
        shipingtonghua
    },
    data() {
        return {
            currentTime: '',
            timeC: null,
            infoTisp: false,
            isLoading: false,
            keyword: "", //搜索
            onFullScreen: false, // 是否全屏
            echartOne: null, // 服务比例统计echarts
            echartTwo: null, // 服务对象比例统计echarts
            personNum: [],
            productName: [],
            productDate: [],
            selfDate: [],
            oldService: [],
            providerPersonList: [],
            textList: [], //老人评价
            map: null, //地图实例
            formationInfoList: [], //改造信息列表
            markers: [], //地图标记点
            dialogVisible: false,
            stepIndex: 1,
            dialogTitle: "",
            formData: {
                name: "",
                sex: "",
                age: "",
                idCode: "",
                phone: "",
                olderType: "",
            },
            nameList: [],
            allData: {},
            serviceTwo: {},
            serviceFour: {},
            cid: '',
            orgList: [],
            serviceData: [],
            stationData: [],
            customeData: [],
            userinfo: {},
            videoModal: false,
            infoData: {},
            typeValue: null,
            regionId: '',
            polygons: [],
            deptOptions: [],
            oldIndex: 0,
            infotitle: '',
            orgName: ''
        }
    },
    async created() {
        this.listDept()
        this.orgName = this.$store.state.info.orgName
        this.regionId = this.$store.state.info.orgId
        this.cid = this.regionId
    },
    beforeDestroy() {
        // 组件销毁前清除定时器  
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    filters: {
    },
    _methods: {
        listDept() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/getUserOrgTree",
                    method: "POST",
                    data: {
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            let arr = [res.content]
                            this.deptOptions = this.handleTree(arr, "deptId");
                        }
                    }
                })
        },
        /** 转换机构数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.orgId,
                label: node.label,
                children: node.children,
            };
        },
        deptSelect(item) {
            this.orgName = item.label
            this.cid = item.orgId
            // this.areaBG(this.map, this.orgName)
            // this.map.setZoom(8)
        },
        // 获取时间
        getTime() {
            let yy = new Date().getFullYear()
            let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1
            let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()
            let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds()
            this.currentTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
        },
        currentTime1() {
            setInterval(this.getTime, 500)
        },
        //所有数据
        getOneList() {
            this.$http
                .request({
                    url: "/jjyl/admin/homePage/bigScreen/info/findAllData",
                    method: "POST",
                    data: {
                        dataId: this.cid
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.allData = res.content
                            this.serviceTwo = {
                                残疾人之家: this.allData.disabledOrderCount,
                                民政: this.allData.clOrderCount,
                                残联: this.allData.clOrderCount,
                                托养中心: this.allData.tyzxOrderCount
                            }
                            this.serviceFour = {
                                残疾人之家: this.allData.disabledCustomerCount,
                                民政: this.allData.mzCustomerCount,
                                残联: this.allData.clCustomerCount,
                                托养中心: this.allData.tyzxCustomerCount
                            }
                            this.getEcharts(this.serviceTwo)
                            this.getEcharts1(this.serviceFour)
                        }
                    }
                })
        },
        textStyle: {
            color: "#D8DDE3",
            rich: {
                name: {
                    verticalAlign: "right",
                    align: "left",
                    fontSize: 18,
                    color: "#D8DDE3",
                },
                percent: {
                    padding: [0, 0, 0, 10],
                    color: "#D8DDE3",
                    fontSize: 18,
                },
            },
        },
        formatter: (name) => {
            const item = chartData.find((i) => {
                return i.name === name;
            });
            const p = ((item.value / sum) * 100).toFixed(0);
            return "{name|" + name + "}" + "{percent|" + p + "}" + " %";
        },
        //服务对象比例
        getEcharts(edata) {
            var chartDom = document.getElementById("echartsTwo")
            var myChart = echarts.init(chartDom)
            this.echartOne = myChart
            var option
            var img =
                "data:image/png;base64,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";
            var trafficWay = this.getArray(edata)
            var istotal = 0
            trafficWay.forEach((item) => {
                istotal += item.value
            })
            if (istotal === 0) {
                return false
            }
            var data = [];
            var color = [
                "#B4FFF0",
                "#D67DFF",
                "#3AD4FF",
                "#7AC2FF",
                "#ffa800",
                "#ff5b00",
                "#ff3000",
            ];
            var sum = 0
            var width = this.echartOne.getWidth();
            var height = this.echartOne.getHeight();
            var imgSize = Math.min(width, height) * 0.35;
            var leftV = (width * 0.9 - imgSize) / 2
            var topV = (height * 0.7 - imgSize - 8) / 2
            for (var i = 0; i < trafficWay.length; i++) {
                data.push(
                    {
                        value: trafficWay[i].value,
                        name: trafficWay[i].name,
                        itemStyle: {
                            normal: {
                                borderWidth: 5,
                                shadowBlur: 20,
                                borderColor: color[i],
                                shadowColor: color[i],
                            },
                        },
                    },
                    {
                        value: 2,
                        name: "",
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
                                },
                                labelLine: {
                                    show: false,
                                },
                                color: "rgba(0, 0, 0, 0)",
                                borderColor: "rgba(0, 0, 0, 0)",
                                borderWidth: 0,
                            },
                        },
                    }
                );
            }
            var seriesOption = [
                {
                    name: "",
                    type: "pie",
                    clockWise: false,
                    radius: ['47%', "50%"],
                    center: ['45%', '34%'],
                    hoverAnimation: false,
                    itemStyle: {
                        normal: {
                            label: {
                                show: false,
                            },
                            labelLine: {
                                show: false,
                            },
                        },
                    },
                    data: data,
                    label: {
                        show: false,
                    },
                },
            ];
            option = {
                color: color,
                title: {
                    text: "",
                    top: "29.5%",
                    textAlign: "center",
                    left: "44%",
                    textStyle: {
                        color: "#fff",
                        fontSize: '0.3rem',
                        fontWeight: "400",
                    },
                },
                graphic: {
                    elements: [
                        {
                            type: "image",
                            z: 3,
                            style: {
                                image: img,
                                width: imgSize,
                                height: imgSize,
                            },
                            left: leftV,
                            top: topV,
                            position: [100, 100],
                        },
                    ],
                },
                tooltip: {
                    show: false,
                },
                legend: {
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 16,
                    bottom: '6%',
                    // left: '35%',
                 //   width: '60%',
                  //  layout: 'row', // 水平排列
                    orient: 'vertical', // 根据可用空间自动调整
                    textStyle: {
                        color: "#fff",
                        rich: {
                            name: {
                                fontSize: 11,
                                color: "#fff",
                            },
                            percent: {
                                padding: [0, 0, 0, 8],
                                color: "#fff",
                                fontSize: 11,
                            },
                        },
                    },
                    formatter: (name) => {
                        const item = trafficWay.find((i) => {
                            return i.name === name;
                        });
                        let total = trafficWay.reduce((acc, item) => acc + item.value, 0); // 更简洁的求和方式
                        const percentage = ((item.value / total) * 100).toFixed(0);

                        return `{name|${name}}{percent|${percentage} %}`;
                    },

                },
                toolbox: {
                    show: false,
                },
                series: seriesOption,
            };
            option && this.echartOne.setOption(option)
        },
        getEcharts1(edata) {
            var chartDom = document.getElementById("echartsFour")
            var myChart = echarts.init(chartDom)
            this.echartTwo = myChart
            var option
            let barWidth = 20 /* 进度条及进度条radius宽度 */,
                nameWidth = 60 /* 进度条名称宽度 */,
                attaData = [] /* 进度条数据 */,
                attaVal = [] /* 进度条数值 */,
                topName = [] /* 进度条名称 */,
                salvProMax = []; /* 背景条数据 */
            var datas = this.getArray(edata)
            var istotal = 0
            datas.forEach((item) => {
                istotal += item.value
            })
            if (istotal === 0) {
                return false
            }
            var colors = ["#57EAE7", "#D67DFF", "#7AC2FF", "#B4FFF0", "#B4FFF0"];
            var bgcolors = ["#2D5E7A", "#424177", "#424177", "#4B7089", "#B4FFF0"];
            datas.forEach((it, i) => {
                topName[i] = `${it.name}`;
                attaVal[i] = it.value;
                attaData[i] = {
                    value: parseFloat(it.value).toFixed(2),
                };
            });
            /* 该值无具体作用，取进度最大值 * 1.2 */
            salvProMax = Array(attaVal.length).fill(Math.max(...attaVal) * 12);
            console.log(attaVal, salvProMax, 'salvProMax')
            option = {
                backgroundColor: "transparent",
                tooltip: {
                    show: false,
                    backgroundColor: "rgba(3,169,244, 0.5)", //背景颜色（此时为默认色）
                    textStyle: {
                        fontSize: 16,
                    },
                },
                grid: {
                    left: "5%",
                    right: "0%",
                    top: "8%",
                    bottom: "0%",
                    containLabel: true,
                },
                legend: {
                    show: false,
                },
                xAxis: {
                    show: false,
                },
                yAxis: [
                    {
                        //名称
                        type: "category",
                        inverse: true,
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        data: topName,
                    },
                    {
                        type: "category",
                        inverse: true,
                        axisTick: "none",
                        axisLine: "none",
                        show: false,
                        data: attaVal,
                    },
                ],
                series: [
                    // 进度条
                    {
                        zlevel: 1,
                        name: "",
                        type: "bar",
                        barGap: 30,
                        barWidth: barWidth,
                        animationDuration: 1500,
                        data: attaData,
                        align: "center",
                        itemStyle: {
                            normal: {
                                barBorderRadius: barWidth,
                                color: function (params) {
                                    //params 传递过来的柱子对象
                                    // dataIndex 是当前柱子的索引
                                    var num = colors.length;
                                    return colors[params.dataIndex % num];
                                },
                            },
                        },
                        label: {
                            show: true,
                            fontSize: 12,
                            distance: 5,
                            position: [0, "-100%"],
                            formatter: "{b}",
                            offset: [0, 0],
                            color: "#BABABA",
                        },
                    },
                    // 背景条
                    {
                        name: "",
                        type: "bar",
                        barWidth: 28,
                        barGap: "-116%",
                        data: salvProMax,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 4,
                                color: function (params) {
                                    //params 传递过来的柱子对象
                                    // dataIndex 是当前柱子的索引
                                    var num = bgcolors.length;
                                    return bgcolors[params.dataIndex % num];
                                },
                            },
                            emphasis: {
                                color: "rgba(165, 213, 232, 1)",
                            },
                        },
                        label: {
                            show: true,
                            position: ["90%", "-100%"],
                            fontSize: 12,
                            color: "#fff",
                            offset: [0, 12],
                            rich: {
                                b: {
                                    color: "#fff",
                                    fontSize: 12,
                                },
                            },
                            formatter: function (param) {
                                for (var i = 0; i < datas.length; i++) {
                                    if (param.name == datas[i].name) {
                                        return "{b|" + datas[i].value + "}";
                                    }
                                }
                            },
                        },
                    },
                ],
            };
            option && this.echartTwo.setOption(option)
        },
        getArray(disabilityData) {
            const data = [];
            // 遍历对象并收集数据  
            for (const key in disabilityData) {
                if (disabilityData.hasOwnProperty(key)) {
                    data.push({
                        name: key,
                        value: disabilityData[key]
                    });
                }
            }
            return data
        },
        //跳转页面
        oldClick(i) {
            this.oldIndex = i
        },
        refreshClick(i) {
            this.oldIndex = i
            if (i === 0) {
                this.handleSearch()
            }
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        formatDate(dateStr) {
            // 将日期字符串从 'YYYY-MM-DD' 格式转换为 'MM.DD' 格式  
            const [year, month, day] = dateStr.split('-').map(Number);
            return `${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
        },
        handleClose() {
            this.dialogVisible = false
        },
        showVideo() {
            this.userinfo = this.infoData
            this.videoModal = true
        },
        //获取服务站打点
        getStation() {
            this.$http
                .request({
                    url: "/ypt/admin/serviceStation/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                        dataId: this.cid
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.stationData = res.content.list || []
                            let data = this.stationData.filter(
                                (item) => item.addressLng && item.addressLat
                            )
                            data.forEach((item) => {
                                item.longitude = item.addressLng
                                item.latitude = item.addressLat
                            })
                            this.renderMapMarker(data, 2)
                        }
                    }
                })
        },
        handleSearch(sign = "", id = "") {
            let self = this
            self.map.remove(this.markers)
            self.markers = []
            self.cid = self.regionId
            self.loadMap()
            self.getOneList()
            //定位打点
            this.getStation()
        },
        renderMapMarker(data, value) {
            var image = null
            // image = require("@/assets/img/map/serviceStation.png")
            let self = this
            data.forEach((item) => {
                if (item.statType == '695') {  //残联
                    image = require("@/assets/img/map/serviceStation.png")
                } else if (item.statType == '696') {  //民政
                    image = require("@/assets/img/map/zise.png")
                } else if (item.statType == '697') {
                    image = require("@/assets/img/map/lvse.png")
                } else {
                    image = require("@/assets/img/map/lanse.png")
                }
                var endIcon = new AMap.Icon({
                    size: new AMap.Size(40, 47),
                    image: image,
                    imageSize: new AMap.Size(32, 36),
                })
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: endIcon,
                })

                self.markers.push(marker)
                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    self.dialogVisible = true
                    this.typeValue = value
                    if (value === 1) {
                    } else if (value === 2) {
                        this.infoData = item //
                        this.infotitle = '服务站点基本信息'
                        this.infoData.personPhone = item.phone
                        this.infoData.personPhoto = item.photo
                    }
                    // self.getElderlyInformation(item.id)
                    // self.getById(item.id)
                })
            })
            self.map.add(self.markers)
            // self.map.add(self.polygon)
            //  self.map.setFitView(self.polygon) //视口自适应
        },
        //循环遍历地址
        async loopAddress() { },
        async init() {
            this.currentTime1(), //获取时间
                this.getOneList()
            this.$nextTick(() => {
                setTimeout(async () => {
                    //太慢了 先去掉
                    await this.getStation()
                }, 100)
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    _mapStyle: "amap://styles/darkblue",
                    get mapStyle() {
                        return this._mapStyle
                    },
                    set mapStyle(value) {
                        this._mapStyle = value
                    },
                    zoom: 8,
                })
                this.areaBG(this.map, this.orgName)
                this.map.setZoom(8)
                this.map.setCenter([119.015372, 33.61037])
                resolve()
            })
        },
        areaBG(map, cityName) {
            let vm = this
            if (vm.polygons && vm.polygons.length > 0) {
                vm.polygons.forEach(polygon => {
                    vm.map.remove(polygon); // 从地图上移除多边形
                });
                vm.polygons = []; // 清空存储多边形的数组
            }
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            vm.polygons.push(polygon)
                        }
                    }
                })
            })
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 3,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0].districtList)
                    }
                })
            }).catch((err) => {
            })
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
    async mounted() {
        let self = this
        await self.loadMap()
        window.addEventListener("resize", () => {
            // 自适应所有echarts
            const handleResize = () => {
                if (!checkFull()) {
                    self.onFullScreen = false
                }
            }
            window.onresize = handleResize
            function checkFull() {
                let isFull =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement
                if (isFull === undefined) isFull = false
                return isFull
            }
            self.$nextTick(() => {
                self.echartOne && self.echartOne.resize() // 服务对象统计echarts
                self.echartTwo && self.echartTwo.resize() //改造人数统计echarts
                this.getEcharts(this.serviceTwo)
            })
        })
        this.init()
        // const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    beforeDestory() {
        window.removeEventListener("resize")
    },
}
</script>
<style>
html,
body {
    overflow: hidden;
}
</style>
<style lang="less" scoped>
/deep/.vue-treeselect__control {
    background: transparent !important;
    border: 1px solid #57EAE7 !important;
}

/deep/.vue-treeselect__single-value,
/deep/.vue-treeselect__placeholder {
    color: #fff !important;
    font-size: 13px;
    line-height: 26px !important
}

/deep/.vue-treeselect__control {
    height: 26px !important;
}

/deep/.vue-treeselect__menu {
    display: block !important;
    z-index: 9999;
}

.small {
    color: #fff;
    font-size: 16px;
    text-align: center;
    padding-top: 15px;
}

/deep/.el-dialog__headerbtn {
    top: 16px;
}

/deep/.speinfo {
    background: #2D497D;
    border: 1px solid #91CDFF;

    .el-dialog__header {
        padding: 5px 6px;
        margin: 8px 9px;
        background: #6181BC;
        border: 1px solid #91CDFF;

        .el-dialog__title,
        .el-dialog__close {
            font-size: 13px;
            color: #fff;

            .el-dialog__headerbtn {
                top: 16px;
            }
        }
    }

    .img {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border-radius: 4px;
        margin-right: 10px;
    }

    .top {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;
        }

        .right {
            width: 132px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #91CDFF;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
            color: #fff;
            font-size: 12px;
        }

        .add {
            display: flex;

            .first {
                white-space: nowrap;
            }
        }
    }

    .el-dialog__body {
        padding: 11px 16px;
    }
}

#typeChart,
#degreeChart {
    width: 90%;
    height: 250px;
}

.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}

.nameoftransition-enter,
.nameoftransition-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.bigdata_container {
    * {
        box-sizing: content-box;
    }
}

/deep/ .serach_wrapper {
    z-index: 100;
    position: absolute;
    right: 5%;
    top: 30px;
    transform: translateX(-50%);
    display: flex;

    .el-button {
        color: #0291c2;
        background: #041d4d;
        border: none;
    }

    .el-button--small {
        padding: 5px 6px;
    }

    .el-input__inner {
        color: #0291c2;
        background: #102132;
        border-color: #233b87;
    }
}

.gdData {
    margin-left: 42px;
    margin-top: 4.7vh;

    .img {
        width: 8vh;
        height: 8vh;
        margin-right: 26px;
    }
}

.gdData {
    .h-flex {
        display: flex;
        margin-bottom: 3.6vh;
        align-items: center;

        .title {
            font-size: 12px;
            color: #fff;
            margin-top: 11px;
        }

        .value {
            color: #57EAE7;
            font-size: 14px;
        }
    }
}

.fourV {
    display: flex;
    flex-wrap: wrap;
    margin-left: 16px;
    margin-top: 4.3vh;

    .h-flex {
        margin-right: 2%;
        width: 48%;
        margin-bottom: 4.4vh;

        .img {
            margin-right: 8px;
        }
    }

    .h-flex:nth-child(2n) {
        margin-right: 0
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../../../assets/img/homecare/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .info_tisp {
        min-width: 380px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: #ebeef5;
        position: fixed;
        left: 50%;
        top: 20px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        background-color: #edf2fc;
        border-radius: 5px;
        -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s,
            -webkit-transform 0.4s;
        padding: 15px;
        display: flex;
        align-items: center;
        line-height: 1;

        .el-message__icon {
            margin-right: 10px;
        }
    }

    .header {
        margin: auto;
        width: 100%;
        height: 77px;
        background: url("../../../assets/img/homecare/topbg.png") no-repeat center center;
        background-size: 100%;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 30px;
    }

    .bigdata_main {
        position: absolute;
        left: 0;
        top: 50px;
        right: 0;
        bottom: 0;

        .main_pane {
            // background: linear-gradient( 180deg, rgba(35,58,100,0) 0%, #233A64 100%);
            background: #1B3054;
            height: 44vh;
            position: relative;
            z-index: 999;
        }

        .main_pane1 {
            height: 38vh;
        }

        .main_left {
            position: absolute;
            top: 4%;
            bottom: 0%;
            left: 1%;
            width: 20%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_center {
            position: absolute;
            top: 4%;
            // bottom: 5%;
            right: 22.5%;
            left: 22.5%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_right {
            position: absolute;
            top: 4%;
            bottom: 0%;
            right: 1%;
            width: 20%;
            overflow-y: auto;

            .main_pane4 {
                height: 38vh;
            }

            .main_pane5 {
                .titleBox {
                    height: 21.7vh;
                    overflow-y: hidden;
                }
            }

            .main_pane6 {
                .titleBox {
                    overflow-y: auto;
                    height: 150px;
                    padding: 15px 10px;

                    .inline {
                        overflow-y: auto;
                        height: 150px;

                        &::-webkit-scrollbar {
                            width: 0 !important;
                            height: 0 !important;
                        }
                    }
                }
            }

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .titleHeader {
            background: url("../../../assets/img/homecare/part.png") no-repeat;
            background-size: 100%;
            height: 6vh;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .tititleTxttleIcon {
                display: inline-block;
                height: 5.4vh;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 18px;
                line-height: 4.1vh;
                color: #fff;
                margin-left: 10%;
                white-space: nowrap;
            }
        }

        .iconimg {
            // background: url("../assets/img/title-icon.png") no-repeat center
            //     center;
            background-size: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .titleIcon {
                display: inline-block;
                height: 37px;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 0.8rem;
                line-height: 37px;
                color: #569cea;
            }
        }

        .titleBox {
            width: 100%;
            padding: 0 12px;
            box-sizing: border-box;
            border: 1px solid #1b3074;

            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                li {
                    margin-top: 20px;
                    width: 25%;
                    color: #ffffff;
                    text-align: center;
                    line-height: 1;

                    .bgimg {
                        font-family: Unidtrsmled;
                        font-size: 16px;
                        // background: url("../assets/img/9.png") no-repeat center
                        //     center;
                        background-size: 100%;
                        display: inline-block;
                        border-radius: 5px;
                        color: #02e0e4;
                        width: 70%;
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }

                    p {
                        font-family: "Unidtrsmled";
                        margin-top: 6px;
                        font-size: 12px;
                    }
                }
            }

            .li {
                padding-left: 4px;
                font-size: 14px;
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                color: #fff;
                line-height: 24px;

                .img {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    font-family: Unidtrsmled;
                }

                .txt {
                    margin-left: 20px;
                    width: 52%;
                    overflow: hidden;
                    height: 18px;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    text-align: center;
                }

                .time {
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                }
            }
        }

        .flex1 {
            display: flex;
            flex-direction: column;
        }

        .datatype {
            display: flex;
            justify-content: space-between;

            li {
                .data {
                    height: 30px;
                    line-height: 30px;
                    font-size: 18px;
                    color: #fff;
                    padding: 0 10px;
                    margin-bottom: 6px;
                    font-weight: bold;
                    background: linear-gradient(90deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%)
                }

                .unit {
                    font-size: 12px;
                }

                span {
                    color: #fff;
                    font-size: 14px;
                }
            }
        }

        .map {
            position: relative;
            margin-top: 30px;
            text-align: center;
            color: #4ac3ff;
            // height: 100%;
            padding: 0 24px;
            //   background: url("../assets/img/tc.png") no-repeat center center;
            // background-size: 100% 100%;

            .title_wrap {
                position: absolute;
                top: -0%;
                left: 50%;
                font-weight: bold;
                transform: translateX(-50%);
            }

            &:nth-child(1) {
                position: relative;
                top: -10px;
                position: relative;
                padding: 30px 3px 5px;
                box-sizing: border-box;
                overflow: hidden;

                .map_wrapper {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    // background: url("../assets/img/tc.png") no-repeat center
                    //     center;
                    background-size: 100% 100%;
                }
            }

            &:nth-child(1) {
                margin-top: 4px;
            }
        }
    }

    .time {
        font-size: 14px;
        color: #fff;
        top: 37px;
        position: absolute;
        left: 20px;
    }

    .quanp {
        width: 20px;
        height: 20px;
        float: right;
        position: absolute;
        top: 31px;
        right: 28px;
        z-index: 999;

        .screen {
            width: 100%;
            height: 100%
        }
    }
}

// 弹框步骤条样式
/deep/ #el-step {
    margin-bottom: 30px;

    .el-step__icon.is-text {
        border-radius: 5px;
    }

    .is-finish .el-step__icon {
        background: #409eff;
    }

    .el-step__icon {
        width: auto;
        padding: 22px 38px;
        color: #ffffff;
        cursor: pointer;
        border: none;
        background: #c0c4cc;
    }

    .el-step {
        height: 40px;
        margin-bottom: 24px;
    }

    .el-step.is-horizontal .el-step__line {
        top: 20px;
    }
}

.check_form_item {
    img {
        width: 100px;
        height: 100px;
    }
}

.el-step.is-center /deep/.el-step__line {
    right: -27%;
    left: 73%;
    border-top: 1px solid #c8b226;
    background-color: transparent;
}

/deep/ .check_form_item,
/deep/ .acceptance_form_item {
    display: flex;
    flex-direction: column;

    .el-form-item__label {
        width: 100% !important;
        margin-bottom: 12px;
        text-align: left;
        border-bottom: 1px solid #c0c4cc;
    }

    /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
}

.user_info {
    /deep/ .el-form-item {
        margin-bottom: 20px;
    }
}

// /deep/ .check_form_item {
//   display: flex;
// }
.check_upload {
    display: inline-block;

    &+.check_upload {
        margin-left: 12px;
    }

    .avatar-uploader {
        line-height: 1;
    }

    .photo {
        font-size: 0;

        img {
            width: 100px;
            height: 100px;
        }
    }

    /deep/ .el-button {
        width: 100px;
        padding: 0;
        line-height: 35px;
        margin-top: 5px !important;
    }
}

.photo {
    font-size: 0;

    img {
        width: 160px;
        height: 160px;
    }
}

/deep/.el-dialog {
    background: #092267;
    opacity: 0.8;
}

#el-step /deep/.el-step__icon {
    background: none;
    color: #c8b226;
    border: 1px solid #c8b226;
}

#el-step /deep/.is-finish .el-step__icon {
    background: #c8b226;
    color: #fff;
}

/deep/.dialog_container .el-dialog__footer {
    background: #092267;
    border-top: none;
    opacity: 0.8;
    text-align: center;

    .el-button {
        border: 1px solid #4a93dc;
        color: #fff;
        margin-bottom: 8px;
        background: #092267;
    }

    .el-button:hover {
        background: #092267;
    }
}

/deep/.el-form-item__label {
    color: #fff;
}

.el-input.is-disabled /deep/.el-input__inner {
    background-color: #85b6db;
    color: #fff;
    opacity: 0.55;
    border: none;
}

.el-textarea.is-disabled /deep/.el-textarea__inner {
    background-color: #85b6db;
    color: #fff;
    border: none;
    opacity: 0.55;
}

/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

/deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

.assessment_upload {
    height: auto;
    width: 100%;
    overflow: hidden;
    position: relative;

    ul {
        width: auto;
        height: auto;
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        justify-content: space-between;

        li {
            margin-left: 20px;
            width: 150px;

            .avatar-uploader {
                width: 100%;

                img {
                    width: auto;
                    min-width: 160px;
                    height: 120px;
                }
            }

            .el-button {
                width: 100%;
            }

            &:nth-child(1) {
                margin-left: 0;
            }
        }
    }
}
</style>
